module.exports = __webpack_public_path__ + "img/social_value_content1.f25a62a3.png";